import '../../styles/common-components/Required.css';

function Required() {
  return <span className="required">*</span>;
}

export default Required;
